

<div class="custom-search-tab">
  @if (showFilterIcon) {
    <div class="filter">
      <label class="basic-label custom-label">{{labelData.viewby}}:</label>
      <mat-select class="custom-mat-select" placeholder="eatec settings" [value]="1">
        @for (viewOption of ViewByOptions; track viewOption) {
          <mat-option [value]="viewOption.id">
            {{viewOption.viewValue}}
          </mat-option>
        }
      </mat-select>
      <i (click)="openFilter()" [ngClass]="{'disabled': originalTableData <= 1 && !_CommonService.iconShow && !hasCheckedFilter()}" (shown)='showFilter()' (hidden)="closeFilter()" class="icon-filter custom-filter-icon" container="body" #filterIcon placement="left" [popoverClass]="popoverClass" [autoClose]="'outside'" [ngbPopover]="(checkOnlineStatusforClick != false) && popContent" [popoverTitle]="(checkOnlineStatusforClick != false) && popTitle" triggers="click outsideClick"></i>
      @if (_CommonService.iconShow) {
        <span class='fil-circle'></span>
      }
    </div>
  }
  @if (showSort) {
    <div class="sort">
      <label class="basic-label custom-label">{{labelData.sortby}}:</label>
      <i class="icon-sort-by custom-filter-icon" #sortIcon container="body" [ngbPopover]="(checkOnlineStatusforClick != false) && sortContent" [autoClose]="'outside'" (click)="openSort()" placement="bottom-right" [ngClass]="{'disabled': itemLength <= 1}">&nbsp;</i>
      <ng-template #sortContent >
        <div class="sortToolTipWrap">
          <mat-radio-group name="sortSelected" [(ngModel)]="defaultSort" (change)="sortChange($event.value,true)">
            @for (sort of sortByOptions; track sort) {
              <mat-radio-button class="sort-radio" [value]="sort.viewValue">{{sort.viewValue}}</mat-radio-button>
            }
          </mat-radio-group>
        </div>
      </ng-template>
    </div>
  }
  <div class="search" [ngStyle]="{width: (showFilterIcon && showSort) ? 'calc(100% - 80px)' : (showFilterIcon ? 'calc(100% - 40px)': '100%')}">
    <label class="basic-label custom-label">{{labelData.showfilter}}</label>
            <div class="custom-search-wrapper" [ngClass]="(itemLength <= 1 && !searchapplied && !_CommonService.iconShow && !hasCheckedFilter()) ? 'disabled': ''">
      <app-auto-completesearch class="custom-auto-search" [searchdataInput]="searchdataInput" [searchoptionalParams]="searchoptionalParams"
        (returnData)="receivedData($event)" (ApiSearchData)="ApiSearchData($event)" (clearSearch)="clearAutoSearch()" [checkOnlineStatusforSearch]="checkOnlineStatusforClick"
      (emitOffineNoDataforSearch)="emitOffineNoDataforAutocompleteSearch()" (callFocusOut)="autocompleteFO()" (callFocusIn)="autocompleteFI()" (searchApplied)="searchApplied($event)"></app-auto-completesearch>
    </div>
  </div>
</div>

<div class="search-popover">
  <ng-template #popTitle>
    <div class="filterpop-title header-row">
      <div class="header-col-one">
        <label>{{'common.filterby' | translate }}</label>
      </div>
      <div class="header-col-two">
        <button mat-button (click)="clearData()" [disabled]="disableClearAll">{{'common.clearAll' | translate}}</button>
      </div>
    </div>
  </ng-template>
  <ng-template #popContent>
    <div class='popover-content-body'>
      @if (multipleData) {
        <mat-accordion>
          @for (filterList of innerfilterArray; track filterList) {
            @if (!filterList.noAccordion) {
              <mat-expansion-panel (afterExpand)="accordianOpen(filterList)">
                <mat-expansion-panel-header>
                  <mat-panel-title>{{filterList.value}}</mat-panel-title>
                </mat-expansion-panel-header>
                @if (filterList.filterType === 'daterange') {
                  <div class="date-range-filter">
                    <mat-form-field appearance="outline" class="filter-date-field">
                      <mat-label>{{'common.from' | translate}}</mat-label>
                      <input matInput [matDatepicker]="fromPicker" readonly
                             (click)="fromPicker.open()"
                             [(ngModel)]="filterList.fromDate"
                             (dateChange)="onDateRangeChange(filterList)">
                      <mat-datepicker-toggle matSuffix [for]="fromPicker"></mat-datepicker-toggle>
                      <mat-datepicker #fromPicker panelClass="filter-datepicker-panel" (opened)="datePickerOpened()" (closed)="datePickerClosed()"></mat-datepicker>
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="filter-date-field">
                      <mat-label>{{'common.to' | translate}}</mat-label>
                      <input matInput [matDatepicker]="toPicker" readonly
                             (click)="toPicker.open()"
                             [(ngModel)]="filterList.toDate"
                             [min]="filterList.fromDate"
                             (dateChange)="onDateRangeChange(filterList)">
                      <mat-datepicker-toggle matSuffix [for]="toPicker"></mat-datepicker-toggle>
                      <mat-datepicker #toPicker panelClass="filter-datepicker-panel" (opened)="datePickerOpened()" (closed)="datePickerClosed()"></mat-datepicker>
                    </mat-form-field>
                  </div>
                }
                @if (filterList.filterType !== 'daterange') {
                  @if (filterList.filterType === 'toggle') {
                    <div class="pop-boby toggle-filter-row">
                      <mat-slide-toggle class="base-slide-toggle"
                        [(ngModel)]="filterList.innervalue[0].checked"
                        (change)="selectFilter(filterList, filterList.innervalue[0], $event)">
                      </mat-slide-toggle>
                    </div>
                  }
                  @if (filterList.filterType !== 'toggle') {
                    @for (FilterInner of filterList.innervalue | sort: (filterList.jsonKey == 'transTypeId' ? filterList.key : filterList.jsonKey)
                      :(filterList.jsonKey == 'transTypeId' ? 'asc' : 'desc') : 'filter'; track FilterInner) {
                      <div class="pop-boby">
                        @if (FilterInner.id != -1) {
                          <span>
                            <mat-checkbox class="base-check-box"  labelPosition="before" [(ngModel)]="FilterInner.checked" (change)="selectFilter(filterList, FilterInner, $event)">{{FilterInner.value}}</mat-checkbox>
                          </span>
                        }
                      </div>
                    }
                  }
                }
              </mat-expansion-panel>
            }
          }
        </mat-accordion>
        @for (filterList of innerfilterArray; track filterList) {
          @if (filterList.noAccordion && filterList.filterType === 'daterange') {
            <div class="no-accordion-date-range">
              <span class="date-range-label">{{filterList.value}}</span>
              <div class="date-range-single-bar">
                <input class="date-part-input"
                       [matDatepicker]="noAccFromPicker"
                       placeholder="DD/MM/YYYY"
                       [(ngModel)]="filterList.fromDate"
                       name="filterFromDate"
                       (dateChange)="onDateRangeChange(filterList)"
                       readonly
                       (click)="noAccFromPicker.open()">
                <span class="date-sep">—</span>
                <input class="date-part-input"
                       [matDatepicker]="noAccToPicker"
                       placeholder="DD/MM/YYYY"
                       [(ngModel)]="filterList.toDate"
                       name="filterToDate"
                       [min]="filterList.fromDate"
                       (dateChange)="onDateRangeChange(filterList)"
                       readonly
                       (click)="noAccToPicker.open()">
                <mat-datepicker-toggle class="inline-cal-toggle" [for]="noAccFromPicker" [disableRipple]="true"></mat-datepicker-toggle>
                <mat-datepicker #noAccFromPicker
                  panelClass="filter-datepicker-panel"
                  (opened)="datePickerOpened()"
                  (closed)="datePickerClosed()">
                </mat-datepicker>
                <mat-datepicker #noAccToPicker
                  panelClass="filter-datepicker-panel"
                  (opened)="datePickerOpened()"
                  (closed)="datePickerClosed()">
                </mat-datepicker>
              </div>
            </div>
          }
        }
      }
      @if (!multipleData) {
        <div>
          @for (FilterInner of innerfilterArray; track FilterInner) {
            <div class="pop-boby">
              @if (FilterInner.id != -1) {
                <span>
                  <mat-checkbox class="base-check-box" labelPosition="before" [(ngModel)]="FilterInner.checked" (change)="selectFilter(filterList, FilterInner, $event)">{{FilterInner.value}}</mat-checkbox>
                </span>
              }
            </div>
          }
        </div>
      }
    </div>

    <div class="popover-footer">
      <button mat-button class="large-button-mobile-confirm confirm-button" (click)="applyFilter($event)" [disabled]='disableFilterButton'>{{'common.apply' | translate}}</button>
    </div>
  </ng-template>


</div>

